import React, { useEffect, useState, useCallback, useRef } from "react";
import { CircularProgress, Typography, IconButton, TextField, Button, Dialog, Menu, MenuItem, DialogContentText, DialogActions, DialogContent, DialogTitle, LinearProgress } from '@mui/material';
import { MdDownloadForOffline, MdOutlineUploadFile } from 'react-icons/md';
import { Tooltip } from 'react-tooltip';
import Order from "./Order";
import DetailsModal from "./DetailsModal";
import AssignModal from "./AssignModal"; // Import AssignModal
import '../Css/OldBills.css';
import Logger from './Logger';
import AddIcon from '@mui/icons-material/Add';
import { Edit as EditIcon, Save as SaveIcon } from '@mui/icons-material';
import { FaListUl } from "react-icons/fa";
import { getLoggerBaseURL } from '../utils/getLoggerBaseURL';

function OldBills() {
    const userEmail = sessionStorage.getItem('userEmail');
    const [selectedOption, setSelectedOption] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [searchQuery, setSearchQuery] = useState('');
    const [orders, setOrders] = useState([]);
    const [selectedOrderId, setSelectedOrderId] = useState(null);
    const [showDModal, setShowDModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState(null);
    const [loading, setLoading] = useState(true);
    const [selectedOrders, setSelectedOrders] = useState([]); // Add selectedOrders state
    const [showModal, setShowModal] = useState(false); // For AssignModal
    const [editingOrderId, setEditingOrderId] = useState(null); // State to track which order is being edited
    const [newBalanceAmount, setNewBalanceAmount] = useState({});
    const [isErrorModalOpen, setIsErrorModalOpen] = useState(false); // State to control the error modal
    const [uploadError, setUploadError] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const [showCancelModal, setShowCancelModal] = useState(false);
    const [isUploadSuccessful, setIsUploadSuccessful] = useState(false);
    const [uploading, setUploading] = useState(false);
    const [selectedOrderIds, setSelectedOrderIds] = useState([]);
    const [uploadProgress, setUploadProgress] = useState(0);

    const logger = useRef(new Logger(getLoggerBaseURL())).current;

    useEffect(() => {
        const fetchUserData = async () => {
            try {
                const response = await fetch(`/api/getUsersEmail/${userEmail}`);
                if (response.ok) {
                    const userData = await response.json();
                    const Old = userData.user.oldstatus;
                    setIsUploadSuccessful(Old);
                } else {
                    logger.log('Failed to fetch user data for Navbar', 'ERROR');
                }
            } catch (error) {
                logger.log(`Error fetching user data: ${error.message}`, 'ERROR');
            }
        };

        if (userEmail) {
            fetchUserData();
        }
    }, [userEmail, logger]);

    const handleOrderDetailsClick = async (orderId) => {
        setSelectedOrderId(orderId);
        setShowDModal(true);
        const selectedOrder = orders.find(order => order._id === orderId);
        setSelectedOrder(selectedOrder);
    };

    const handleSelectOrder = (orderId, isChecked) => {
        if (isChecked) {
            setSelectedOrders([...selectedOrders, orderId]);
        } else {
            setSelectedOrders(selectedOrders.filter(id => id !== orderId));
        }
    };

    const handleSelectAll = (isChecked) => {
        if (isChecked) {
            setSelectedOrders(filteredOrders.map(order => order._id));
        } else {
            setSelectedOrders([]);
        }
    };

    const handleAssignmentComplete = useCallback(() => {
        setSelectedOrders([]);
        setShowModal(false);
    }, []);

    const handleFileUpload = (event) => {
        const file = event.target.files[0];
        const formData = new FormData();
        formData.append('file', file);

        setUploading(true);
        setUploadError(null);
        setUploadProgress(0);

        const xhr = new XMLHttpRequest();
        fetch(`/api/ordera/api/oldbills/upload/${userEmail}`, {
            method: 'POST',
            body: formData // assuming you're sending a FormData object
        })
            .then(response => {
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }
                return response.json();
            })
            .then(data => {
                logger.log('Old bills upload success:', 'INFO');
            })
            .catch(error => {
                logger.log(`Old bills upload failed: ${error.message}`, 'ERROR');
            });

        // Event listener for upload progress
        xhr.upload.onprogress = (event) => {
            if (event.lengthComputable) {
                const percentCompleted = Math.round((event.loaded * 100) / event.total);
                setUploadProgress(percentCompleted);
            }
        };

        xhr.onload = () => {
            setUploading(false);
            if (xhr.status === 200) {
                alert('Data uploaded and saved successfully.');
                window.location.reload();
            } else {
                const data = JSON.parse(xhr.responseText);
                const errorMessage = Array.isArray(data.message)
                    ? data.message.join('\n')
                    : data.message || 'Incorrect Format';
                setUploadError(errorMessage);
                handleOpenErrorModal(); // Adjust this as per your actual error handling logic
            }
        };

        xhr.onerror = () => {
            setUploading(false);
            setUploadError('An unexpected error occurred while uploading the file.');
        };

        xhr.send(formData);
    };

    const downloadDemoExcel = () => {
        const link = document.createElement('a');
        link.href = "/assets/OldBill.xlsx";
        link.download = "OldBillsSample.xlsx";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
    };

    useEffect(() => {
        const fetchOrders = async () => {
            try {
                const response = await fetch(`/api/ordera/oldBills/${userEmail}`);
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                const data = await response.json();

                if (data === null || data.length === 0) {
                    setOrders([]);
                } else {
                    setOrders(data);
                }
            } catch (error) {
                logger.log(`Error fetching data: ${error.message}`, 'ERROR');
                setOrders([]);
            } finally {
                setLoading(false);
            }
        };
        fetchOrders();
    }, [userEmail, logger]);

    const filteredOrders = (() => {
        const start = new Date(startDate);
        const end = new Date(endDate);

        return orders.filter(order => {
            const orderDate = new Date(order.creation_date);
            const isInDateRange = (!startDate || !endDate) || (orderDate >= start && orderDate <= end);
            const matchesSearchQuery = selectedOption === "OrderNo" ?
                order.Order_No.toLowerCase().includes(searchQuery.toLowerCase()) :

                selectedOption === "CAddress" ?
                    order.Rec_Add.toLowerCase().includes(searchQuery.toLowerCase()) :
                    order.Rec_Name.toLowerCase().includes(searchQuery.toLowerCase());

            return isInDateRange && matchesSearchQuery;
        });
    })();

    const handleAssignClick = useCallback((orderId) => {
        setSelectedOrderId(orderId);
        setShowModal(true);
    }, []);

    const handleCloseModal = () => {
        setShowDModal(false);
        setSelectedOrderId(null);
        setSelectedOrder(null);
    };

    const handleOpenAssignModal = () => {
        setShowModal(true);
    };

    const handleCloseAssignModal = () => {
        setShowModal(false);
    };

    const handleStatusUpdated = useCallback(() => {
        // Fetch the updated orders data from the backend
        const fetchUpdatedOrders = async () => {
            try {
                const response = await fetch(`/api/ordera/oldBills/${userEmail}`);
                if (!response.ok) {
                    throw new Error(`HTTP error! Status: ${response.status}`);
                }

                const data = await response.json();
                if (data === null || data.length === 0) {
                    setOrders([]); // Set orders to an empty array if no data
                } else {
                    setOrders(data);
                }
            } catch (error) {
                logger.log(`Error fetching updated data: ${error.message}`, 'ERROR');
            }
        };

        fetchUpdatedOrders();
    }, [userEmail, logger]);

    const handleEditBalance = (orderId) => {
        setEditingOrderId(orderId); // Set the order being edited
        setNewBalanceAmount(orders.find(order => order._id === orderId).dueamount); // Initialize with the current amount
    };


    const handleSaveBalance = async (orderId) => {
        // Save the new balance amount to the backend
        try {
            const response = await fetch(`/api/ordera/updateBalance/${userEmail}/${orderId}`, {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ dueamount: newBalanceAmount }),

            });
            if (response.ok) {
                // Update the state with the new balance amount
                setOrders(orders.map(order =>
                    order._id === orderId ? { ...order, dueamount: newBalanceAmount } : order
                ));
                setEditingOrderId(null); // Exit edit mode
            } else {
                logger.log(`Failed to update balance amount for order ${orderId}`, 'ERROR');
                throw new Error('Failed to update balance amount');
            }
        } catch (error) {
            logger.log(`Error updating balance amount: ${error.message}`, 'ERROR');
        }
    };

    const handleBalanceChange = (event) => {
        setNewBalanceAmount(event.target.value);
    };

    const downloadErrorMessages = () => {
        const element = document.createElement('a');
        const file = new Blob([uploadError], { type: 'text/plain' });
        element.href = URL.createObjectURL(file);
        element.download = 'error_messages.txt';
        document.body.appendChild(element); // Required for this to work in FireFox
        element.click();
        document.body.removeChild(element);
        setIsErrorModalOpen(false); // Close the modal after downloading
    };

    const handleOpenErrorModal = () => {
        setIsErrorModalOpen(true);
    };

    const handleThreeDotsClick = (event, orderId) => {
        if (anchorEl === event.currentTarget) {
            // If the same anchorEl is clicked again, close the dropdown
            setAnchorEl(null);
        } else {
            // Otherwise, set the anchorEl to the clicked element
            setAnchorEl(event.currentTarget);
            setSelectedOrderId(orderId); // Set the selected order ID
        }
    };

    const handleCloseMenu = () => {
        setAnchorEl(null);
    };

    const handleOpenCancelModal = (orderId) => {
        if (!Array.isArray(orderId)) {
            // If orderIds is not already an array, wrap it in an array
            orderId = [orderId];
        }
        setSelectedOrderIds(orderId);
        setShowCancelModal(true);
    };

    const handleCancelOrder = async () => {
        try {
            await fetch(`/api/ordera/delete/${userEmail}`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    orderIds: selectedOrderIds
                }),
            });
            // Remove the deleted order from the state
            setOrders(orders.filter(order => !selectedOrderIds.includes(order._id)));
            setShowCancelModal(false); // Close the confirmation modal
        } catch (error) {
            logger.log(`Error cancelling order: ${error.message}`, 'ERROR');
        }
    };

    const handleCloseCancelModal = () => {
        setShowCancelModal(false);
    };

    const handleViewDetailsDropdownClick = (orderId) => {
        const selectedOrder = orders.find(order => order._id === orderId);
        setSelectedOrder(selectedOrder);
        setShowDModal(true); // Open the details modal
    };

    return (
        <div>
            <Order searchQuery={searchQuery} setSearchQuery={setSearchQuery} selectedOption={selectedOption} setSelectedOption={setSelectedOption} startDate={startDate} setStartDate={setStartDate} endDate={endDate} setEndDate={setEndDate} />

            {isUploadSuccessful === false ? (
                <div className="oldbill-actions">
                    <div className='oldbills'>
                        <button className='choose-file-button-order' onClick={downloadDemoExcel} style={{ cursor: 'pointer' }} data-tooltip-id="download-oldbills-tooltip">
                            <MdDownloadForOffline size={30} />
                        </button>
                        <Tooltip id="download-oldbills-tooltip" place="bottom" content="Download OldBills Sample Excel" />
                    </div>

                    <input accept=".xlsx,.xls" style={{ display: 'none' }} id="upload-oldbills-file" type="file" onChange={handleFileUpload} autocomplete="off" />
                    <label htmlFor="upload-oldbills-file" className='upload-oldbills-file' style={{ cursor: 'pointer' }}>
                        <div data-tooltip-id="upload-oldbills-tooltip">
                            <MdOutlineUploadFile size={30} />
                        </div>
                    </label>
                    <Tooltip id="upload-oldbills-tooltip" place="bottom" content="Upload OldBills Excel" />
                </div>
            ) : null}

            <div>
                {uploading ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                        <LinearProgress variant="determinate" value={uploadProgress} style={{ width: '80%', marginBottom: '10px' }} />
                        <Typography variant="h6">{`Uploading... ${uploadProgress}%`}</Typography>
                    </div>
                ) : loading ? (
                    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
                        <CircularProgress />
                        <Typography variant="h6" style={{ marginTop: '20px' }}>Fetching data...</Typography>
                    </div>
                ) : (
                    <>
                        <table className="cTable">
                            <thead>
                                <tr>
                                    <th>
                                        <input type="checkbox" onChange={(e) => handleSelectAll(e.target.checked)} checked={filteredOrders.length > 0 && selectedOrders.length === filteredOrders.length} autocomplete="off" />
                                    </th>
                                    <th className="thC"><strong>Order No.</strong></th>
                                    <th className="thC"><strong>Receiver Name</strong></th>
                                    <th className="thC"><strong>Receiver Address</strong></th>
                                    <th className="thC"><strong>Total Amount</strong></th>
                                    <th className="thC"><strong>Area</strong></th>
                                    <th className="thc"><strong>Invoice Date</strong></th>
                                    <th className="thC"><strong>MR Name</strong></th>
                                    <th className="thC"><strong>Balance Amount</strong></th>
                                    <th className="thC"><strong>Due Date</strong></th>
                                    <th className="thC"><strong>Assign</strong></th>
                                    <th className="thC"><strong>Comments</strong></th>
                                    <th className="thC"><strong>Mobile Number</strong></th>
                                    <th className="Cth"><strong>Actions</strong></th>
                                </tr>
                            </thead>
                            <tbody>
                                {filteredOrders.length === 0 ? (
                                    <tr>
                                        <td className="noOrders" colSpan="9">
                                            <div className="center-content">
                                                <div className="icon-wrapper">
                                                    <FaListUl className="icon" />
                                                </div>
                                                <span className="noOrdersMsg">No Order found</span>
                                            </div>
                                        </td>
                                    </tr>
                                ) : (
                                    filteredOrders.map(order => (
                                        <tr key={order._id}>
                                            <td>
                                                <input type="checkbox" checked={selectedOrders.includes(order._id)} onChange={(e) => handleSelectOrder(order._id, e.target.checked)} autocomplete="off" />
                                            </td>
                                            <td className="tdC">
                                                <button className="detailsD" onClick={() => handleOrderDetailsClick(order._id)}>
                                                    <strong>{order.Order_No || 'N/A'}</strong>
                                                </button>
                                            </td>

                                            <td className="tdC">{order.Rec_Name || 'N/A'}</td>
                                            <td className="tdC">{order.Rec_Add || 'N/A'}</td>
                                            <td className="tdC">₹ {order.amount || 'N/A'}</td>
                                            <td className="tdC">{order.area || 'N/A'}</td>
                                            <td className="tdC">{order.IDate || 'N/A'}</td>
                                            <td className="tdC">{order.salesman || order.MR_Name || 'N/A'}</td>
                                            <td className="tdC">
                                                {editingOrderId === order._id ? (
                                                    <>
                                                        <TextField value={newBalanceAmount} onChange={handleBalanceChange} size="small" style={{ width: '80px' }} />
                                                        <IconButton onClick={() => handleSaveBalance(order._id)}>
                                                            <SaveIcon fontSize="small" />
                                                        </IconButton>
                                                    </>
                                                ) : (
                                                    <>
                                                        ₹ {order.dueamount || 'N/A'}
                                                        <IconButton onClick={() => handleEditBalance(order._id)}>
                                                            <EditIcon fontSize="small" />
                                                        </IconButton>
                                                    </>
                                                )}
                                            </td>
                                            <td className="tdC">{order.due_date || 'N/A'}</td>
                                            <td className="tdCu">
                                                {order.o_status === '0' || order.o_status === '6' ? (
                                                    <button className="assignD" onClick={() => handleAssignClick(order._id)}>+Assign</button>
                                                ) : (
                                                    <span className="assigned">{order.driverName || "N/A"}</span>
                                                )}
                                            </td>
                                            <td className="tdC">{order.comment || 'N/A'}</td>
                                            <td className="tdC">{order.Pick_Loc_No || 'N/A'}</td>
                                            <td className="tdCu">

                                                <button className="Dbutton" onClick={(e) => handleThreeDotsClick(e, order._id)}>
                                                    ...
                                                </button>
                                            </td>
                                        </tr>
                                    ))
                                )}
                            </tbody>
                        </table>
                    </>
                )}
            </div>

            {selectedOrders.length > 0 && (
                <IconButton onClick={handleOpenAssignModal} style={{ position: 'fixed', top: '150px', right: '20px', zIndex: 1000 }} data-tooltip-id="assign-tooltip">
                    <Tooltip id="assign-tooltip" place="bottom" content="Assign" />
                    <AddIcon fontSize="large" />
                </IconButton>
            )}

            {showDModal && selectedOrder && (
                <DetailsModal showDModal={showDModal} onClose={handleCloseModal} selectedOrder={selectedOrder} />
            )}

            {showModal && (
                <AssignModal
                    showModal={showModal}
                    onClose={handleCloseAssignModal}
                    oid={selectedOrderId}
                    onStatusUpdated={handleStatusUpdated}
                    selectedOrders={selectedOrders} // Pass selected orders here
                    onAssignmentComplete={handleAssignmentComplete}
                />
            )}

            {/* Error Modal */}
            <Dialog open={isErrorModalOpen} onClose={() => setIsErrorModalOpen(false)}>
                <DialogTitle>Error Messages</DialogTitle>
                <DialogContent>
                    <Typography variant="body1" style={{ color: 'red' }}>
                        {uploadError}
                    </Typography>
                </DialogContent>
                <DialogActions>
                    <Button onClick={() => setIsErrorModalOpen(false)}>Cancel</Button>
                    <Button onClick={downloadErrorMessages} variant="contained" color="primary">
                        Download Errors
                    </Button>
                </DialogActions>
            </Dialog>

            <ActionsDropdown anchorEl={anchorEl} onClose={handleCloseMenu} onViewDetailsClick={handleViewDetailsDropdownClick} orderId={selectedOrderId} onOpenCancelModal={handleOpenCancelModal} />

            <Dialog open={showCancelModal} onClose={handleCloseCancelModal}>

                <DialogTitle>{"Delete Order"}</DialogTitle>
                <DialogContent>
                    <DialogContentText>
                        Are you sure you want to delete the order?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleCloseCancelModal} style={{ backgroundColor: "#f5f5f5", border: "1px solid #ccc", color: "#333", borderRadius: "4px", padding: "6px 12px", }}>
                        Cancel
                    </Button>
                    <Button onClick={handleCancelOrder} style={{ backgroundColor: "#d32f2f", border: "1px solid #d32f2f", color: "white", borderRadius: "4px", padding: "6px 12px", }} autoFocus>
                        Delete
                    </Button>
                </DialogActions>
            </Dialog>

        </div>
    );
}

const ActionsDropdown = ({ anchorEl, onClose, onLabelClick, orderId, onOpenCancelModal }) => {
    return (
        <Menu
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={onClose}
            sx={{
                "& .MuiPaper-root": {
                    boxShadow: '1px 2px 2px 0px rgba(0, 0, 0, 0.1)',
                    backgroundColor: '#fff',
                    borderRadius: '8px',
                    transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                    "&:hover": {
                        transform: 'scale(1.02)',
                        boxShadow: '0px 6px 18px rgba(0, 0, 0, 0.2)',
                    },
                },
                "& .MuiMenuItem-root": {
                    transition: 'background-color 0.3s ease, color 0.3s ease',
                    "&:hover": {
                        backgroundColor: '#f0f0f0',
                        color: '#17c289',
                    },
                },
            }}
        >
            <MenuItem onClick={() => {
                onOpenCancelModal(orderId);
                onClose();
            }}>
                Delete Order
            </MenuItem>
        </Menu>
    );
};

export default OldBills;